module.exports = __webpack_public_path__ + "static/img/other.d7e9c0cd.png";